
import { defineComponent } from "vue";
import { Container, Section, Heading2 } from "@/components/layout";
import { SkillArticle } from "./components";
import { useContent } from "@/hooks";

export default defineComponent({
  name: "Skills",
  components: { Container, Section, Heading2, SkillArticle },
  setup() {
    const { articles } = useContent();

    return { entities: articles };
  },
});
